// ============================================================
// App.js  —  REPLACE your entire existing App.js with this
// ============================================================
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useParams, useLocation } from 'react-router-dom';
import GoldRatesWebsite from './GoldRatesWebsite';
import GoldPriceCountryPage from './GoldPriceCountryPage';import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';

// ── Scroll to top on EVERY route change ──────────────────────────────────────
// Fixes the issue where navigating to a new page kept the scroll position
// from the previous page (e.g. clicking India from mid-page scrolled to middle)
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function CountryPageWrapper() {
  const { slug } = useParams();
  return <GoldPriceCountryPage slug={slug} />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Home */}
        <Route path="/"        element={<GoldRatesWebsite />} />

         {/* Blog — must be BEFORE /:slug so /blog doesn't get caught as a country slug */}
        <Route path="/blog"       element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />

        {/* Standalone HTML pages — handled by the server, not React Router */}
        {/* about.html, privacy-policy.html, contact.html, calculator.html */}


        {/* All 140 country pages — e.g. /gold-price-in-india-inr */}
        <Route path="/:slug"   element={<CountryPageWrapper />} />
      </Routes>
    </BrowserRouter>
  );
}
